(function($){
  
  function hideShowCustomSizeForm() {
    const selectedValue = $('#option1').val();
    let csf = customSizeForm();
    if (selectedValue === "Custom" || selectedValue === "Custom Fit") {
      csf.show();
      validateCustomForm();
    } else {
      csf.hide();
      $('.product-form__cart-submit, .shopify-payment-button__button').prop('disabled', false);
    }
  }

  function customSizeForm()
  {
      return $('#custom-size-form');
  }

  function customFormID()
  {
      let csf = customSizeForm();
      if(csf.length != 0){
        let productId = csf.data('product-id');
        return `#product_form_${productId}`;
      }
      return '';
  }

  function productForm()
  {
    let csf = customSizeForm();
    if(csf.length != 0){
      let productId = csf.data('product-id');
      return $(`#product_form_${productId}`);
    }
    return false;
  }

  function validateCustomForm() {
    let isValid = true;

    $('.csf-input-field').each(function () {
      const $field = $(this);
      const tag = this.tagName.toLowerCase();

      if (tag === 'input' && !$field.val().trim()) {
        $field.addClass('input-error');
        isValid = false;
      } else {
        $field.removeClass('input-error');
      }
    });

    setTimeout(function () {
      $('.product-form__cart-submit, .shopify-payment-button__button').prop('disabled', !isValid);
    }, 250);

    return isValid;
  }

  function validCustomField($field) {
    validateCustomForm();
  }

  function removeCustomFields() {
    let form = productForm();
    if(form){
      form.find('input[name="properties[Measurement Unit]"]').remove();
      $('.csf-input-field').each(function () {
        const name = this.name;
        form.find(`input[name="${name}"]`).remove();
      });
    }
  }

  function addCustomField(field) {
    let form = productForm();
    if(form){
      const name = field.name;
      const value = field.value.trim();
      if (value) {
        form.find(`input[name="${name}"]`).remove();
        $('<input>', {
          type: 'hidden',
          name: name,
          value: value,
          class: 'custom-hidden'
        }).appendTo(form);
      }
    }
  }

  function addCustomDataInForm() {
    const measurementUnit = $('input[name="properties[Measurement Unit]"]:checked')[0];
    if (measurementUnit) addCustomField(measurementUnit);
    $('.csf-input-field').each(function () {
      addCustomField(this);
    });
  }

  function resetFieldValues() {
    let form = productForm();
    if(form){
      form.find('input[name="properties[Measurement Unit]"]').remove();
      $('.csf-input-field').each(function () {
        $(this).val('');
        form.find(`input[name="${this.name}"]`).remove();
      });
    }
  }

  $(document).on('click', '.dynamic-variant-button', function(){
      setTimeout(function(){
        $('#option1').trigger('change');
      }, 100);
  });
  // Handle dynamically rendered select using event delegation
  $(document).on('change', '#option1', function () {
    hideShowCustomSizeForm();
    resetFieldValues();
  });

  // Input & blur handlers for custom fields
  $(document).on('input blur', '.csf-input-field', function () {
    validCustomField($(this));
    addCustomDataInForm();
  });

  // Form submit
  $(document).on('submit', `.product-form`, function (e) {
    let formid = $(this).attr('id');
    let csfid = customFormID();
    if(csfid == formid){
      e.preventDefault();
      const selectedValue = $('#option1').val();
      removeCustomFields();
      if (selectedValue === "Custom" || selectedValue === "Custom Fit") {
        addCustomDataInForm();
      }
    }
  });

  // Trigger on load
  hideShowCustomSizeForm();

})(jQuery);